import React from "react";
import { Table } from "reactstrap";
import Api from "services/api";
import { formatServerDateTime } from "helpers/formatServerDateTime";
import NotificationLogDetailModal from "components/common/NotificationLogDetailModal";

/**
 * "Notifications Log" section on the View Appointment page — every email the system sent
 * about this job, with a preview. `portal="interpreter"` switches to the scoped API that
 * returns only mail addressed to the logged-in interpreter.
 */
const NotificationLogsTable = ({ appointmentId, portal = "admin" }) => {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [detailLogId, setDetailLogId] = React.useState(null);

  React.useEffect(() => {
    if (!appointmentId) return;
    let active = true;
    setRows([]); // clear when navigating between appointments
    setLoading(true);
    const call = portal === "interpreter"
      ? Api.fetchMyNotificationLogs(appointmentId)
      : Api.fetchNotificationLogs(1, { appointment_id: String(appointmentId), pageLength: 100, page: 1 });
    call
      .then((res) => {
        if (!active) return;
        if (res?.status >= 200 && res?.status < 300) {
          const data = res?.data?.data;
          // admin endpoint paginates ({data:[…]}); interpreter endpoint returns a plain list
          setRows(Array.isArray(data) ? data : (data?.data || []));
        }
      })
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [appointmentId, portal]);

  return (
    <div className="card_table p-4">
      <h2 className="main_heading2 mb-3">Notifications Log</h2>
      <div className="table_responsive">
        <Table>
          <thead className="text-primary">
            <tr>
              <th>Sent</th>
              <th>Recipient</th>
              <th>Subject</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={5} style={{ textAlign: "center" }}>Loading…</td></tr>
            ) : rows.length === 0 ? (
              <tr><td colSpan={5} style={{ textAlign: "center" }}>No emails logged for this job yet</td></tr>
            ) : rows.map((log) => (
              <tr key={log.id}>
                <td style={{ whiteSpace: "nowrap" }}>{formatServerDateTime(log.created_at)}</td>
                <td className="text-break" style={{ maxWidth: 260 }}>{log.recipient}</td>
                <td>{log.subject || "(no subject)"}</td>
                <td>
                  <span style={{
                    display: "inline-block", padding: "1px 10px", fontSize: 12, fontWeight: 600,
                    borderRadius: 10, textTransform: "capitalize",
                    background: "#1c7c3633", color: "#1c7c36",
                  }}>
                    {log.status}
                  </span>
                </td>
                <td>
                  <span
                    className="link_preview"
                    style={{ cursor: "pointer" }}
                    onClick={() => setDetailLogId(log.id)}
                  >
                    View
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <NotificationLogDetailModal
        logId={detailLogId}
        isOpen={detailLogId !== null}
        toggle={() => setDetailLogId(null)}
        portal={portal}
      />
    </div>
  );
};

export default NotificationLogsTable;
